export default __webpack_public_path__ + "static/media/PicsArt_05-11-04.23.56 - 075_ ANIKET BHUNIA.d49d75d0.jpg";